import React, { memo } from 'react';

import MuiButton from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';

const StyledIconButton = styled(MuiButton)(({ theme }) => ({
  borderRadius: '8px',
  padding: '8px 12px',
  height: '40px',
  width: '40px',
  minWidth: '40px',
  fontSize: '12px',
  textTransform: 'capitalize',
  background: 'var(--color-surface)',
  border: `1px solid ${theme.palette.divider}`,
  color: theme.palette.text.secondary,
  'svg': {
    fontSize: '20px',
    color: 'var(--color-text-muted)'
  }
}));

const IconButton = ({ onClick, disabled, loading, icon, ...props }) => {
  return (
    <StyledIconButton
      onClick={onClick}
      variant="outlined"
      disabled={disabled}
      {...props}
    >
      {loading ? <CircularProgress size={24} className="button-processing-indicator" /> : icon}
    </StyledIconButton>
  )
};

export default memo(IconButton);
